// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1BW0K","title":"ClientCherryInfo_title__3wvRK","itemText":"ClientCherryInfo_itemText__3GUcq"};